export enum TextStyles {
  'UI_MICRO' = 'ui-micro',
  'UI_COMPACT' = 'ui-compact',
  'UI_DEFAULT' = 'ui-default',
  'DIVIDER' = 'divider',
  'P4' = 'p4',
  'P3' = 'p3',
  'P2' = 'p2',
  'P1' = 'p1',
  'SUBTITLE' = 'subtitle',
  'H6' = 'h6',
  'H5' = 'h5',
  'H4' = 'h4',
  'H3' = 'h3',
  'H2' = 'h2',
  'H1' = 'h1',
  'H0' = 'h0',
}
